var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col",class:{ full: _vm.full }},[_c('button',{style:(_vm.corPrimaria)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }